import Util from "@/lib/util";
import AppConsts from "@/lib/appconst";
export default [
  {
    title: Util.L("Order"),
    key: "orderNo",
    width: 45,
  },
  {
    title: Util.L("Picture"),
    width: 80,
    render: (h: any, params: any) => {
      return h("img", {
        attrs: {
          "v-lazy": Util.getAppUrlImage(params.row.thumbnailUrl),
          src: Util.getAppUrlImage(params.row.thumbnailUrl),
        },
        style: {
          display: "inline-block",
          width: "50px",
        },
      });
    },
  },
  {
    title: Util.L("SKU"),
    width: 200,
    key: "sku",
  },
  {
    title: Util.L("Name"),
    width: 400,
    key: "name",
  },
  {
    title: Util.L("Category"),
    width: 150,
    key: "categoryName",
  },
  {
    title: Util.L("StorageType"),
    width: 100,
    key: "storageType",
    render: (h: any, params: any) => {
      return h(
        "span",
        Util.L(
          AppConsts.tableRef.tableProduct.prefix.storageType +
            params.row.storageType
        )
      );
    },
  },
  {
    title: Util.L("ProductType"),
    width: 150,
    render: (h: any, params: any) => {
      return h(
        "span",
        Util.L(
          AppConsts.tableRef.tableProduct.prefix.productType +
            params.row.productType
        )
      );
    },
  },
  {
    title: Util.L("Type"),
    width: 150,
    key: "poProductTypeName",
  },
  {
    title: Util.L("ExternalCode"),
    width: 200,
    key: "externalCode",
  },
  {
    title: Util.L("BrandName"),
    width: 200,
    key: "brandName",
  },
  {
    title: Util.L("Tax"),
    width: 80,
    key: "tax",
  },
  {
    title: Util.L("Note"),
    width: 200,
    key: "note",
  },
];
